module.exports = __webpack_public_path__ + "img/nasil_acrobat.7c09fdd2.svg";